
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { PloutousBaseService, PloutousStatus, PloutousTrail } from "./PloutousBaseService";

export interface IProcessor {
    code: string;
    name: string;
    color: string;
    balance: number;
    logo_location: string;
}

export interface IBalance {
    tax: number;
}

export class BalanceService extends PloutousBaseService {

    protected static instance: BalanceService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!BalanceService.instance) BalanceService.instance = new BalanceService();
        return BalanceService.instance;
    }

    getCurrencyProcessors(currency: string, params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<IProcessor[]>> {
        return this.report(this.transport.get(`/api/v1/processor/list/${currency}`, { query: this.normalizeParams(params) }));
    }

}
